import useHttp from './use-http';
import {json} from "d3";

const useConfig = () => {
  const host = window.location.hostname;
  let prefix = '/themes/baykis/dist/app-drupal';
  let baseURL = window.location.origin;

  if (
    host.includes('patternlab') ||
    host.includes('styleguide') ||
    host === 'dev.baykis.test' ||
    (host.includes('localhost') && !host.includes('drupal'))
  ) {
    prefix = '';
    baseURL = 'http://drupal_web';
  }

  if (host.includes('baykis.test')) {
    baseURL = 'http://drupal_web';
  }

  const sendRequest = useHttp();

  const getConfig = (configName, callBack, background = false) => {
    const callBackWrapper = (response) => {
      callBack(response[0]);
    };

    sendRequest(`/assets/statics/data/${configName}`, callBackWrapper, background);
  };

  const getSets = async (callback) => {
    getConfig('sets', callback);
  };

  const getSet = async (setName, callback, background = false) => {
    getConfig(`set_${setName}`, callback, background);
  };

  const getBayernGeo = async (callback) => {
    json(`${prefix}/assets/statics/data/baykis_bayern_geo.json`).then((result) => {
        callback(result);
      }
    );
  };

  const getColorSets = async (colorSet, callback) => {
    getConfig(`colorsets${colorSet}`, (data) => {
      callback(data.colorsets);
    });
  };

  const getColorSet = async (colorSet, climateParam, callback) => {
    getConfig(`colorsets${colorSet}`, (data) => {
      const useColors = data.colorsets.filter(
        (obj) => obj.var === climateParam
      );

      callback(useColors);
    });
  };

  const getCellsLonLat = async (callback) => {
    getConfig(`Cells-lon_lat`, callback);
  };

  return {
    getSets,
    getSet,
    getBayernGeo,
    getColorSets,
    getColorSet,
    getCellsLonLat,
  };
};

export default useConfig;
